export const LoadingMessage = {
  DASHBOARD: "Loading your dashboard",
  APPLICATION: "Loading your application",
};
